<template>
  <div class="container">
    <div class="containerBox">
      <div class="logoBox">
        <div class="logo">
          <img src="@/assets/images/logo.png" />
        </div>
        <p class="title">强声视介</p>
        <p class="desc">尊敬的用户，请您仔细阅读页面下方的《隐私政策》，强声视介公众号将依此向您提供服务和收集处理您的个人信息。</p>
      </div>
      <div class="InfoBox">
        <div class="info_title">
          <span class="title">个人信息</span>
          <div class="edit" v-show="!showEdit" @click="showEdit = true">
            <img src="@/assets/images/appraise.png" />
            <span>编辑</span>
          </div>
        </div>
        <div class="notEditInfo" v-show="!showEdit">
          <div class="infoItem">
            <span class="label">姓名</span>
            <span class="info">{{Name}}</span>
          </div>
          <div class="infoItem">
            <span class="label">医院</span>
            <span class="info">{{HospitalName}}</span>
          </div>
          <div class="infoItem">
            <span class="label">职称</span>
            <span class="info">{{PositionName}}</span>
          </div>
          <div class="infoItem">
            <span class="label">科室</span>
            <span class="info">{{DepartmentName}}</span>
          </div>
        </div>
        <div class="editInfo" v-show="showEdit">
          <div class="infoItem1 bottom">
            <span class="label">姓名</span>
            <div class="inputBox">
              <input class="input" type="text" v-model="Name" placeholder="请输入姓名" />
              <img src="@/assets/images/clean.png" @click="Name = ''" />
            </div>
          </div>
          <div class="infoItem1 bottom">
            <span class="label">医院</span>
            <div class="inputBox">
              <input class="input" type="text" v-model="HospitalKeyWords" placeholder="请输入医院" />
              <img src="@/assets/images/clean.png" @click="cleanHospital" />
              <div class="HospitalList" ref="HospitalList" v-show="showHospitalPicker">
                <span v-for="(item, index) in HospitalColumns" :key="index" @click="selectHospital(item.HospitalName, item.HospitalCode)">{{item.HospitalName}}</span>
              </div>
            </div>
          </div>
          <div class="infoItem1 bottom">
            <span class="label">职称</span>
            <div class="inputBox" @click="showPositionPicker = true">
              <span :class="{'placeholder': PositionName == ''}">{{PositionName ? PositionName : '请选择职称'}}</span>
              <!-- <input class="input" type="text" v-model="PositionName" placeholder="请选择职称" /> -->
              <img src="@/assets/images/xiala.png" />
            </div>
          </div>
          <van-popup v-model="showPositionPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="PositionColumns"
              value-key="Titles"
              @cancel="showPositionPicker = false"
              @confirm="onPositionConfirm"
            />
          </van-popup>
          <div class="infoItem1 bottom">
              <span class="label">科室</span>
              <div class="inputBox" @click="showDepartmentPicker = true">
                <span :class="{'placeholder': DepartmentName == ''}">{{DepartmentName ? DepartmentName : '请选择科室'}}</span>
                <img src="@/assets/images/xiala.png" />
              </div>
          </div>
          <van-popup v-model="showDepartmentPicker" round position="bottom">
              <van-picker
                show-toolbar
                :columns="DepartmentColumns"
                value-key="Name"
                @cancel="showDepartmentPicker = false"
                @confirm="onDepartmentConfirm"
              />
          </van-popup>
        </div>
      </div>
      <div class="handleBox">
        <div class="declare" @click="checkedDeclare">
          <img
            :src="
              isCheckedDeclare
                ? require('@/assets/images/system-complete.png')
                : require('@/assets/images/dis_system_complete_icon@2x.png')
            "
          />
          <span class="declareText">我已完整阅读并知晓<span class="highlight" @click="$router.push('/privacyPolicy')">《隐私声明》</span>全部内容，同意强生根据该《隐私声明》和《强生隐私政策》所述目的、范围和方式处理我提供的个人信息。</span>
        </div>
        <div class="handle">
          <!-- <div class="btn cancel" @click="reset">重置</div> -->
          <div class="btn confirm" @click="submit">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import storage from "../../common/utils/storage";

const delay = (function() {
 let timer = 0;
 return function(callback, ms) {
  clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export default {
  name: 'PublicRegister',
  data() {
    return {
      CIAMData: {},
      showEdit: false,
      Phone: '',
      Name: '',
      HospitalKeyWords: '',
      showHospitalPicker: false,
      HospitalColumns: [],
      HospitalCode: '',
      HospitalName: '',
      showPositionPicker: false,
      PositionColumns: [],
      PositionId: '',
      PositionName: '',
      showDepartmentPicker: false,
      DepartmentColumns: [],
      DepartmentCode: '',
      DepartmentName: '',
      list: [],
      isCheckedDeclare: false,
      isLock: true,
      isGetUserInfo: false,
      Gender: null
    }
  },
  computed: {
    ...mapState(['Openid', 'userInfo'])
  },
  watch: {
    HospitalKeyWords(newValue) {
      if (newValue == this.HospitalName) {
        this.showHospitalPicker = false;
      } else {
        delay(() => {
          this.GetHospital();
        }, 300);
      }
    }
  },
  created() {
    if(!this.userInfo) {
      storage.setStore('scope', 'snsapi_userinfo');
      this.$router.push({
        path: '/authorize',
        query: {scope: 'snsapi_userinfo'}
      })
    }
    this.getCIAM();
    this.getPosition();
    this.getDepartment();
    this.getList();

    document.addEventListener('click',(e)=>{
      if(this.$refs.HospitalList){
        let isSelf = this.$refs.HospitalList.contains(e.target)
        if(!isSelf){
          this.showHospitalPicker = false
        }
      }
    })
  },
  methods: {
    getCIAM() {
      this.$axios.get('/Api/Api/Web/GetWxUser/GetCIAM?openid=' + this.Openid).then(res => {
        this.isGetUserInfo = true;
        let datas = res.Data;
        if(datas) {
          this.CIAMData = datas;
          this.Name = datas.RealName;
          this.HospitalCode = datas.HCode;
          this.HospitalKeyWords =datas.HospitalTitle;
          this.HospitalName = datas.HospitalTitle;
          this.PositionId = datas.PositionalId;
          this.PositionName = datas.PositionalName;
          this.Phone = datas.Phone;
          this.DepartmentName = datas.SubjectName;
          this.Gender = datas.Gender;
        }
      })
    },
    getList() {
      this.$axios.get('/Api/Api/Web/GetWxUser/GetDitWebCodeList').then(res => {
        this.list = res.Data;
        let index = res.Data.findIndex(item => item.Code == "other");
        if (index != -1) {
          this.list.splice(index, 1);
        }
      })
    },
    async GetHospital() {
      let res = await this.$axios.post('/Api/Api/Web/GetWxUser/GetHospital?HospitalName=' + this.HospitalKeyWords);
      let data = res.Data;
      if (data.length > 0) {
        this.showHospitalPicker = true;
        this.HospitalColumns = data;
      } else {
        this.showHospitalPicker = false;
        this.HospitalColumns = [];
      }
    },
    selectHospital(HospitalName, HospitalCode) {
      this.HospitalCode = HospitalCode;
      this.HospitalKeyWords = HospitalName;
      this.HospitalName = HospitalName;
      this.showHospitalPicker = false;
    },
    getPosition() {
      this.$axios.get('/Api/Api/Web/GetWxUser/GetTitle').then(res => {
        this.PositionColumns = res.Data;
      })
    },
    onPositionConfirm(value) {
      this.PositionId = value.Id;
      this.PositionName = value.Titles;
      this.showPositionPicker = false;
    },
    // 获取科室
    getDepartment() {
      this.$axios.get('/Api/Api/Web/GetWxUser/GetDepa').then(res => {
        this.DepartmentColumns = res.Data;
      })
    },
    onDepartmentConfirm(value) {
      this.DepartmentCode = value.Id;
      this.DepartmentName = value.Name;
      this.showDepartmentPicker = false;
    },
    checkedDeclare() {
      this.isCheckedDeclare = !this.isCheckedDeclare;
    },
    submit() {
      if (!this.Name) {
        this.$toast('请输入姓名！');
        return false;
      }
      if (!this.HospitalName) {
        this.$toast('请输入所在的医院！');
        return false;
      }
      if (!this.PositionName) {
        this.$toast('请选择职称！');
        return false;
      }
      if (!this.DepartmentName) {
        this.$toast('请选择科室！');
        return false;
      }
      if(!this.isCheckedDeclare) {
        this.$toast('请勾选《隐私声明》并同意！');
        return false;
      }

      // let data = {
      //   OpenID: this.Openid,
      //   RealName: this.Name,
      //   Phone: this.Phone,
      //   HCode: this.HospitalCode,
      //   HospitalTitle: this.HospitalName,
      //   PositionalId: this.PositionId,
      //   PositionalName: this.PositionName,
      //   SubjectName: this.DepartmentName,
      //   Gender: this.Gender
      // }
      // console.log(data)

      this.CIAMData.OpenID = this.Openid;
      this.CIAMData.RealName = this.Name;
      this.CIAMData.Phone = this.Phone;
      this.CIAMData.HCode = this.HospitalCode ? this.HospitalCode : '';
      this.CIAMData.HospitalTitle = this.HospitalName ? this.HospitalName : this.HospitalKeyWords;
      this.CIAMData.PositionalId = this.PositionId;
      this.CIAMData.PositionalName = this.PositionName;
      this.CIAMData.SubjectName = this.DepartmentName;
      this.CIAMData.Gender = this.Gender;
      // console.log(this.CIAMData)

      if (this.isLock) {
        this.isLock = false;
        this.$axios.post('/Api/Api/Web/GetWxUser/UserRegisterNew', this.CIAMData).then((res) => {
          if (res.RetCode == '10000') {
            this.isLock = true;
            storage.setStore('Token', res.Data.Token);
            let redirectUrl = sessionStorage.getItem("redirectUrl");
            if(redirectUrl) {
              this.$router.push(redirectUrl);
              sessionStorage.removeItem('redirectUrl');
            } else {
              this.$router.push('/');
            }
          } else {
            this.isLock = true;
            this.$toast(res.RetMsg);
          }
        })
      }
    },
    reset() {
      this.list.forEach(item => {
        item.sonList.forEach(sonItem => {
          sonItem.isChecked = false;
        })
      })
      this.$forceUpdate();
    },
    cleanHospital() {
      this.HospitalCode = '';
      this.HospitalKeyWords = '';
      this.HospitalName = '';
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/images/bg_comm_png.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #F9F9F9;
  padding-bottom: 200px;
  box-sizing: border-box;
  .containerBox {
    position: relative;
    top: 80px;
    padding: 12px;
    background-color: #F9F9F9;
    border-radius: 12px 12px 0 0;
    box-sizing: border-box;
  }
  .logoBox {
    position: relative;
    top: -36px;
    background-color: #FFFFFF;
    border-radius: 10px;
    padding: 12px;
    .logo {
      position: absolute;
      top: -35px;
      left: 50%;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      // background-color: #FDFDFD;
      transform: translateX(-40px);
      img {
        width: 100%;
        // margin-top: 7px;
        // margin-left: 6px;
      }
    }
    .title {
      font-size: 16px;
      color: #333333;
      text-align: center;
      margin-top: 44px;
      font-weight: bold;
    }
    .desc {
      font-size: 10px;
      color: #999999;
      margin-top: 12px;
      line-height: 14px;
    }
  }
  .InfoBox {
    padding: 12px;
    background-color: #FFFFFF;
    border-radius: 10px;
    margin-top: -25px;
    .info_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
      }
      .edit {
        font-size: 12px;
        color: $themeColor;
        img {
          width: 16px;
          height: 16px;
          margin-right: 2px;
          vertical-align: middle;
        }
      }
    }
    .notEditInfo {
      margin: 15px 0 0;
      // border-bottom: 1px solid #EEEEEE;
    }
    .infoItem {
      font-size: 14px;
      line-height: 29px;
      .label {
        display: inline-block;
        width: 50px;
        color: #999999;
      }
      .info {
        color: #333333;
      }
    }
    .infoItem1 {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 14px;
      .label {
        display: inline-block;
        width: 50px;
        color: #999999;
      }
      .inputBox {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        width: 0;
        height: 36px;
        border: 1px solid #DDDDDD;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 10px;
        color: #333333;
        box-sizing: border-box;
        .input {
          flex: 1;
          border: none;
        }
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    .bottom {
      margin-bottom: 10px;
    }
    .editInfo {
      margin-top: 15px;
    }
    .HospitalList {
      position: absolute;
      top: 40px;
      left: 0;
      z-index: 9;
      width: 100%;
      max-height: 200px;
      background-color: #FFFFFF;
      border-radius: 8px;
      box-shadow: 0 8px 12px #ebedf0;
      overflow-y: scroll;
      span {
        padding: 5px 10px;
        display: block;
        font-size: 12px;
        line-height: 24px;
      }
      span:not(:last-child) {
        border-bottom: 1px solid #ebebeb;
      }
    }
  }
  .picker_content {
    padding: 20px 6px;
    .pickerBox {
      display: flex;
      flex-wrap: wrap;
    }
    .picker_block {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(calc(100% / 3) - 12px);
      height: 36px;
      text-align: center;
      border: 1px solid rgba(153, 153, 153, 0.5);
      box-sizing: border-box;
      margin: 6px;
      border-radius: 4px;
      color: #333333;
      font-size: 14px;
    }
    .activeBg {
      border: none;
      color: #C70C3C;
      background-image: url('../../assets/images/select_system_btn@2x.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .handleBox {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 12px;
    background-color: #FFFFFF;
    box-sizing: border-box;
    box-shadow: 0 4px 12px #dddddd;
    .declare {
      display: flex;
      align-items: flex-start;
      font-size: 13px;
      color: #666666;
      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
        margin-top: 2px;
      }
      .highlight {
        color: $themeColor;
      }
    }
    .handle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      margin: 15px 0;
      .btn {
        width: 100%;
        height: 44px;
        line-height: 44px;
        border-radius: 44px;
        text-align: center;
      }
      .cancel {
        border: 1px solid $themeColor;
        color: $themeColor;
        box-sizing: border-box;
      }
      .confirm {
        color: #FFFFFF;
        background-color: $themeColor;
      }
    }
    .reset {
      color: #000000;
      font-size: 14px;
      text-align: center;
    }
  }
}

/*webkit 内核浏览器*/
input::-webkit-input-placeholder{
  font-size: 14px;
  color: #999999;
}
/*Mozilla Firefox 19+*/
input::-moz-placeholder{
  font-size: 14px;
  color: #999999;
}
/*Mozilla Firefox 4 to 18*/
input:-moz-placeholder{
  font-size: 14px;
  color: #999999;
}
/*Internet Explorer 10+*/
input:-ms-input-placeholder{
  font-size: 14px;
  color: #999999;
}


.placeholder {
  color: #999999 !important;
}
</style>